/**
 * List of all possible features that tenant can have in CRM
 */

export default [
	{
		id: "dashboard",
		i18nKey: "dashboard",
		slug: "dashboard",
		permission: null,
		icon: "dashboard"
	},
	{
		id: "leads",
		i18nKey: "leads",
		slug: "leads",
		permission: null,
		icon: "leads"
	},
	{
		id: "clients",
		i18nKey: "clients",
		slug: "clients",
		permission: ["readIndividuals", "readCompanies"],
		icon: "clients"
	},
	{
		id: "policies",
		i18nKey: "policies",
		slug: "policies",
		permission: "readPolicies",
		icon: "policies"
	},
	{
		id: "quotes",
		i18nKey: "quotes",
		slug: "quotes",
		permission: "readIndividuals",
		icon: "quotes"
	},
	{
		id: "products",
		i18nKey: "products",
		slug: "products",
		permission: "readProducts",
		icon: "products"
	},
	{
		id: "claims",
		i18nKey: "claims",
		slug: "claims",
		permission: "readClaims",
		icon: "claims"
	},
	{
		id: "reports",
		i18nKey: "reports",
		slug: "reports",
		permission: "readIndividuals",
		icon: "reports"
	},
	{
		id: "setup",
		i18nKey: "settings",
		slug: "setup",
		permission: null,
		icon: "settings"
	},
	{
		id: "commissions",
		i18nKey: "commissions",
		slug: "commissions",
		permission: null,
		icon: "commissions"
	},
	{
		id: "internals",
		i18nKey: "participants",
		slug: "internals",
		permission: "readInternals",
		icon: "internals"
	},
	{
		id: "users",
		i18nKey: "users",
		slug: "users",
		permission: null,
		icon: "users"
	},
	{
		id: "notifications",
		i18nKey: "notifications",
		slug: "notifications",
		permission: null,
		icon: "notifications"
	},
	{
		id: "organizations",
		i18nKey: "organizations",
		slug: "organizations",
		permission: null,
		icon: "organizations"
	},
	{
		id: "caseManagement",
		i18nKey: "case_management",
		slug: "case-management",
		permission: null,
		icon: "caseManagement"
	},
	{
		id: "binders",
		i18nKey: "binders",
		slug: "binders",
		permission: null,
		icon: "binders"
	},
	{
		id: "objects",
		i18nKey: "objects",
		slug: "objects",
		permission: null,
		icon: "box"
	},
	{
		id: "fileSystem",
		i18nKey: "file_system",
		slug: "file-system",
		permission: null,
		icon: "folder"
	},
	{
		id: "transactions",
		i18nKey: "transactions",
		slug: "transactions",
		permission: ["readTransactions"],
		icon: "payment"
	},
	{
		id: "plans",
		i18nKey: "plans",
		slug: "plans",
		permission: null,
		icon: "payment"
	},
	{
		id: "education",
		i18nKey: "education",
		slug: "education",
		permission: "readCourses",
		icon: "education"
	},
	{
		id: "achievements",
		i18nKey: "achievements",
		slug: "achievements",
		permission: "readAchievementTypes",
		icon: "achievements"
	},
	{
		id: "resources",
		i18nKey: "resources",
		slug: "resources",
		permission: "readCourses",
		icon: "resources"
	}
]
